import { configureStore } from '@reduxjs/toolkit'
import testScenarioReducer from './slices/testScenarioSlice'
import projectStatusesReducer from './slices/projectStatusesSlice'
import releaseReducer from './slices/releaseSlice'
import folderReducer from './slices/folderSlice'
import reportsReducer from './slices/reportsSlice'
import libraryReducer from './slices/librarySlice'
import navigationContextReducer from './slices/navigationContextSlice'
import issueLinkReducer from './slices/issueLinkSlice'

export const store = configureStore({
  reducer: {
    testScenario: testScenarioReducer,
    projectStatuses: projectStatusesReducer,
    releases: releaseReducer,
    folders: folderReducer,
    reports: reportsReducer,
    library: libraryReducer,
    navigationContext: navigationContextReducer,
    issueLinks: issueLinkReducer
  }
})
